import React from 'react'
import First from './first/First'
import Second from './second/Second'
import Third from './third/Third'

function Banner() {
  return (
    <>
      <First/>
      <Second/>
      <Third/>
    </>
  )
}

export default Banner
